<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.3 19.9" fill="currentColor">
    <g>
      <path
        d="M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-1.7a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6Z"
      />
      <path
        d="M14 10c0-2.3-.6-4.4-1.8-6.2-.2-.3-.6-.4-1-.2-.3.3-.3.7 0 1 1 1.5 1.5 3.4 1.5 5.4 0 2-.6 3.8-1.6 5.3-.2.3-.2.7.2 1 .3.2.7.1.9-.2 1.2-1.7 1.9-3.9 1.9-6.1Z"
      />
      <path
        d="M11 10c0-1.7-.5-3.3-1.4-4.5-.2-.3-.6-.4-.9-.1-.3.2-.4.6-.1 1 .7.9 1 2.2 1 3.6 0 1.3-.3 2.6-1 3.6-.3.3-.2.7.1 1 .3.2.7.1 1-.2A7.6 7.6 0 0 0 11 10ZM8 10c0-1-.4-2-.9-2.8a.7.7 0 0 0-1-.2c-.3.3-.3.7 0 1 .3.5.5 1.2.5 2 0 .7-.2 1.4-.5 1.9-.3.3-.2.7 0 1 .4.2.8 0 1-.2.5-.7.8-1.7.8-2.7Z"
      />
    </g>
  </svg>
</template>
